<template>
  <div class="work-space-sidebar-container">
    <el-scrollbar class="work-space-sidebar-scrollbar"
      v-if="!workSpaceTarget"
    >
      <div class="work-space-entity"
        v-for="(entity, entityIndex) of dataList"
        :key="entityIndex"
        @click="workSpaceClick(entity)"
        :title="entity['name']"
      >
        <div class="entity-title ellipsis">
          {{ entity['name'] }}
        </div>
        <div class="entity-control">
          <span title="发布服务" @click.stop="serviceUploadFn(entity)">
            <svg-icon iconName="service-upload"></svg-icon>
          </span>
          <!-- <span title="数据导出" @click.stop="fileExportFn(entity)">
            <svg-icon iconName="file-export"></svg-icon>
          </span> -->
          <span title="修改" @click.stop="editFn(entity)">
            <svg-icon iconName="el-Edit"></svg-icon>
          </span>
          <span title="删除" @click.stop="deleteFn(entity)">
            <svg-icon iconName="el-Delete"></svg-icon>
          </span>
        </div>
      </div>
    </el-scrollbar>
    <WorkSpaceData
      v-else
      :workSpace="workSpaceTarget"
      @close="workSpaceTargetClear"
    ></WorkSpaceData>
    <EditWorkSpace 
      v-if="editWorkSpaceShowFlag"
      :target="editWorkSpaceTarget"
      :title="editWorkSpaceTitle"
      @close="editWorkSpaceShowFlagChange(false)"
      @submitCallback="dataInit"
    >
    </EditWorkSpace>
    <ServiceUpload
      v-if="serviceUploadTarget"
      @close="serviceUploadTargetChange(undefined)"
      :target="serviceUploadTarget"
    ></ServiceUpload>
  </div>
</template>

<script setup>
import { 
  onBeforeMount, onMounted, onUnmounted, onUpdated,
  computed, watch, ref, nextTick
} from 'vue';
import { isNull, dayjs, message } from '@/utils/js/initVariable';
import { ElMessageBox } from 'element-plus';

import store from '@/store';
import EditWorkSpace from './components/EditWorkSpace';
import WorkSpaceData from './components/WorkSpaceData';
import ServiceUpload from './components/ServiceUpload';
import { exportWorkspace, } from '@/api/ExportData';

import {
  queryWorkspaceList, delWorkspace,
} from '@/api/UserWorkspaceApi';
// props
const props = defineProps({
  
});
// emit
const emit = defineEmits([
  
]);

const workSpaceTarget = ref(),
workSpaceClick = (target)=>{
  workSpaceTarget.value = target;
},
workSpaceTargetClear = ()=>{
  workSpaceTarget.value = undefined;
}

const fileExportFn = (target)=>{
  // console.log(target);
  exportWorkspace(target).then(res=>{
    if(res.data.code == 1004){
      message(res.data.msg, 1);
    }
  }).catch(err=>{
    console.log(err);
  });
}

const serviceUploadTarget = ref(), serviceUploadTargetChange = (target)=>{
  serviceUploadTarget.value = target;
}
const serviceUploadFn = (target)=>{
  serviceUploadTarget.value = Object.assign({}, target);
}

const dataList = ref([]),
dataInit = ()=>{
  queryWorkspaceList({}).then(res=>{
    if(res.data.code == 1004){
      dataList.value = res.data.dataList;
    }
  }).catch(err=>{
    console.log(err);
  });
}

const deleteFn = (target)=>{
  ElMessageBox.confirm(
    '是否删除当前快照？',
    '删除快照',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }
  ).then(res=>{
    delWorkspace(target['id']).then(res=>{
      if(res.data.code == 1004){
        message(res.data.msg, 1);
        dataInit();
      }
    }).catch(err=>{
      console.log(err);
    });
  }).catch(err=>{
    console.log(err);
  });
}

const editWorkSpaceTarget = ref(), editWorkSpaceTitle = ref(),
      editWorkSpaceclose = ()=>{
        editWorkSpaceTarget.value = undefined;
        editWorkSpaceTitle.value = undefined;
      },
      editWorkSpaceShowFlag = ref(false),
      editWorkSpaceShowFlagChange = (flag)=>{
        editWorkSpaceShowFlag.value = flag;
        if(!flag){
          editWorkSpaceclose();
        }
      }
const editFn = (target)=>{
  editWorkSpaceTitle.value = '修改快照';
  editWorkSpaceTarget.value = Object.assign({}, target);
  editWorkSpaceShowFlagChange(true);
}
const addWorkSpaceFn = ()=>{
  editWorkSpaceTitle.value = '新增快照';
  editWorkSpaceShowFlagChange(true);
}

defineExpose({
  addWorkSpaceFn,
})

// 组件挂载前
onBeforeMount(()=>{

});
// 组件挂载后
onMounted(()=>{
  dataInit();
});
// 组件更新后
onUpdated(()=>{

});
// 组件销毁后
onUnmounted(()=>{

});

</script>

<style lang='less'>

</style>

<style lang='less' scoped>
.work-space-sidebar-container{
  height: 100%;
  width: 100%;
  padding: 8px 5px;
  .work-space-sidebar-scrollbar{
    :deep(.el-scrollbar__view){
      display: flex;
      flex-direction: column;
      gap: var(--padDefaultSize);
      .work-space-entity{
        // border: 2px solid var(--borderColor_10);
        border-radius: var(--borderRadiusSize);
        padding: var(--padDefaultSize);
        // background-color: var(--backgroundColor_21);
        backdrop-filter: blur(5px);
        cursor: pointer;
        &:hover{
          // border-color: var(--borderColor_6);
          background-color: var(--backgroundColor_21);
        }
        .entity-title{
          line-height: 24px;
          font-size: 16px;
          color: var(--fontColor_24);
        }
        .entity-control{
          text-align: right;
          span+span{
            margin-left: 5px;
          }
          .svg-icon{
            cursor: pointer;
            &:hover{
              fill: var(--iconColor_5);
              color: var(--iconColor_5);
            }
          }
        }
      }
    }
  }
}
</style>